import styled, { css } from 'styled-components';
import { ReactComponent as ArrowIcon } from './arrowDown.svg';

export const SpoilerWrapper = styled.div`
  padding: 24px;
  border-radius: 10px;
  background: #f4f5f6;
`;

export const SpoilerSummary = styled.p`
  color: rgba(9, 21, 38, 0.85);
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 133.333% */
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
`;

export const Arrow = styled(ArrowIcon)<{ show: boolean }>`
  cursor: pointer;
  flex-shrink: 0;

  ${(props) =>
    props.show &&
    css`
      transform: rotate(180deg);
    `};
`;

export const ArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SpoilerContentRoller = styled.div<{ isOpen: boolean; height: number }>`
  overflow: hidden;
  height: ${({ isOpen, height }) => (isOpen ? `${height}px` : '0px')};
  transition: height 0.3s ease;
`;

export const SpoilerContent = styled.div``;
